import { Tab, Tabs } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { useCallback, useEffect, useState } from 'react';
import { Switch, useHistory, useLocation } from 'react-router-dom';
import GeolocationCard from '../../pages/PeopleManagement/GeolocationCard';
import PunchCardManagement from '../../pages/PeopleManagement/PunchCard';
// import BreadcrumbsNavigation from '../BreadcrumbsNavigation';
import Route from '../Route';
import { RouteItem, ROUTES } from '../routes';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabsContainer: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      minHeight: 36,
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    tabContent: {
      minHeight: 36,
      textTransform: 'none',
    },
  }),
);

export const peopleManagementRoutes: RouteItem[] = [
  ROUTES.PEOPLE_MANAGEMENT_PUNCH_CARD,
  ROUTES.PEOPLE_MANAGEMENT_GEOLOCATION_CARD,
];

const PeopleManagementNavigation: React.FC = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const [tabSelected, setTabSelected] = useState(() => {
    const routeIndex = peopleManagementRoutes.findIndex(item =>
      location.pathname.includes(item.path),
    );

    return routeIndex === -1 ? 0 : routeIndex;
  });

  useEffect(() => {
    if (
      tabSelected === 0 &&
      !location.pathname.includes(peopleManagementRoutes[0].path)
    ) {
      history.push(peopleManagementRoutes[0].path);
    }
  }, [history, tabSelected, location.pathname]);

  const handleTabChange = useCallback(
    (event: React.ChangeEvent<unknown>, newValue: number) => {
      setTabSelected(newValue);
    },
    [],
  );

  const handleTabClick = useCallback(
    (tabItem: RouteItem) => {
      history.push(tabItem.path);
    },
    [history],
  );

  return (
    <>
      <Tabs
        className={classes.tabsContainer}
        value={tabSelected}
        onChange={handleTabChange}
        textColor="inherit"
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        {peopleManagementRoutes.map((item, index) => {
          return (
            <Tab
              key={index}
              onClick={() => handleTabClick(item)}
              className={classes.tabContent}
              label={item.title}
            />
          );
        })}
      </Tabs>
      {/* <BreadcrumbsNavigation /> */}
      <Switch>
        <Route
          path={ROUTES.PEOPLE_MANAGEMENT_PUNCH_CARD.path}
          component={PunchCardManagement}
        />
        <Route
          path={ROUTES.PEOPLE_MANAGEMENT_GEOLOCATION_CARD.path}
          component={GeolocationCard}
        />
      </Switch>
    </>
  );
};

export default PeopleManagementNavigation;
